import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  MultiSelect,
  MultiSelectProps,
  Text,
  rem,
} from "@mantine/core";
import {
  useDebouncedCallback,
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
} from "@mantine/hooks";
import {
  IconBarcode,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconFileExport,
  IconSearch,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItemModel } from "../../../model/SelectListItem";
import { useLocation } from "react-router-dom";
import { getMasterOrgSelect } from "../../../service/getSelectApi";

const InventoryReportByBarcodeV2 = () => {
  // Khởi tạo component InventoryReportList
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<InventoryItem[]>([]);
  const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
  const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);
  const [dataBranchCode, setDataBranchCode] = useState<any[]>([]);
  const [dataBranchIdSelect, setDataBranchIdSelect] = useState<string[]>([]);
  const [dataCatSegment4d, setDataCatSegment4d] = useState<
    SelectListItemModel[]
  >([]);
  const [searchCatSegment4d, setSearchCatSegment4d] = useState<string>("");
  const [debounceCatSegment4d] = useDebouncedValue<string>(
    searchCatSegment4d,
    500,
  );

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const sizeGrid = { base: 12, sm: 6, md: 6, lg: 1.85 };
  const [rowCount, setRowCount] = useState(0);
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson.keySearch : "",
    500,
  );
  const [serial, setSerial] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson.serial : "",
    500,
  );
  const [search, setSearch] = useState({
    branchCode: [],
    invCode: [],
    itemCode: [],
    maChungs: [],
  });
  const [isSearchWithItemCodeOrSerial, setIsSearchWithItemCodeOrSerial] =
    useState<boolean>(false);

  type InventoryItem = {
    idBranch: number;
    branchCode: string;
    branchName: string;
    idKho: number;
    maKho: string;
    tenKho: string;
    idVt: number;
    maVt: string;
    tenVt: string;
    maSp: string;
    tenSp: string;
    maBarcode: string;
    dvt: string;
    soLuong: number;
    ngayNhap: string;
    tuoiTon: number;
    soPhieuNhap: string;
    donGiaNhap: number;
    maNcc: string | null;
    tenNcc: string | null;
    maChung: string;
    tenChung: string;
    maNhom: string;
    tenNhom: string;
    trangThai: string;
    ghiChuTrangThai: string;
    maNganh: string;
    tenNganh: string;
    maLoai: string;
    tenLoai: string;
    segment1Code: string;
    segment1Name: string;
    segment6Code: string | null;
    segment6Name: string | null;
    plvt1Code: string | null;
    plvt1Name: string | null;
    plvt3Code: string | null;
    plvt3Name: string | null;
    plvt4Code: string | null;
    plvt4Name: string | null;
    plvt5Code: string | null;
    plvt5Name: string | null;
    plvt6Code: string | null;
    plvt6Name: string | null;
  };

  const handleChangeSearchValue = (value: string[] | null, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : [],
    }));
  };

  const handleChangeSearch = (value: string | null, key: string) => {
    setSearch((prevData) => ({
      ...prevData,
      [key]: value ? value : 0,
    }));
  };

  const formatNumber = (number: number) => {
    return new Intl.NumberFormat("vi-VN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };

  const columns = React.useMemo<MRT_ColumnDef<InventoryItem>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
      },
      {
        accessorKey: "soPhieuNhap",
        header: "Số phiếu nhập",
        size: 150,
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Badge
              style={{ cursor: "pointer" }}
              bd="1px solid blue"
              variant="light"
              color="blue"
            >
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "maBarcode",
        header: "Mã vạch",
      },
      {
        accessorKey: "branchCode",
        header: "Mã chi nhánh",
        size: 150,
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Button
              variant="light"
              p="4px 8px"
              radius="xl"
              size="xs"
              color="violet"
              fw="bold"
            >
              {renderedCellValue}
            </Button>
          </>
        ),
      },
      {
        accessorKey: "branchName",
        header: "Tên chi nhánh",
      },
      {
        accessorKey: "maNcc",
        header: "Mã NCC",
      },
      {
        accessorKey: "tenNcc",
        header: "Tên NCC",
      },
      {
        accessorKey: "maKho",
        header: "Mã kho",
        size: 150,
      },
      {
        accessorKey: "tenKho",
        header: "Tên kho",
        size: 200,
      },
      {
        accessorKey: "maVt",
        header: "Mã vị trí",
        size: 150,
      },
      {
        accessorKey: "tenVt",
        header: "Tên vị trí",
      },
      {
        accessorKey: "maSp",
        header: "Mã sản phẩm",
        size: 160,
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue ?? "Không có mã sản phẩm"}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "maNganh",
        header: "Mã ngành",
      },
      {
        accessorKey: "tenNganh",
        header: "Tên ngành",
        size: 200,
      },
      {
        accessorKey: "maLoai",
        header: "Mã loại",
      },
      {
        accessorKey: "tenLoai",
        header: "Tên loại",
      },
      {
        accessorKey: "maChung",
        header: "Mã chủng",
      },
      {
        accessorKey: "tenChung",
        header: "Tên chủng loại",
        size: 200,
      },
      {
        accessorKey: "maNhom",
        header: "Mã nhóm",
      },
      {
        accessorKey: "tenNhom",
        header: "Tên nhóm",
      },
      // {
      //   accessorKey: "MaNhom",
      //   header: "Mã nhóm",
      // },
      // {
      //   accessorKey: "TenNhom",
      //   header: "Tên nhóm",
      // },
      {
        accessorKey: "tenSp",
        header: "Tên sản phẩm",
        size: 350,
      },
      {
        accessorKey: "dvt",
        header: "Đơn vị tính",
        size: 140,
        footer: "Tổng:",
        Footer(props) {
          return (
            <div>
              <Text c="red" fw={800}>
                {props.column.columnDef.footer}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "soLuong",
        header: "Số lượng",
        size: 130,
        Footer: ({ table }: any) => {
          const total = table
            .getRowModel()
            .rows.reduce(
              (sum: number, row: any) => sum + (row.original?.soLuong || 0),
              0,
            );
          return (
            <div>
              <Text c="red" fw={800}>
                {total}
              </Text>
            </div>
          );
        },
      },
      {
        accessorKey: "ngayNhap",
        header: "Ngày nhập",
        size: 150,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "tuoiTon",
        header: "Tuổi tồn",
        size: 150,
        Cell: ({ renderedCellValue }: any) => (
          <>
            {/* {renderedCellValue
              ? calculateDaysDifference(renderedCellValue)
              : "N/A"} */}
            {renderedCellValue}
          </>
        ),
      },

      {
        accessorKey: "donGiaNhap",
        header: "Đơn giá nhập",
        size: 150,
        Cell: ({ renderedCellValue }: any) => (
          <>{formatNumber(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "segment1Code",
        header: "Mã phân đoạn 1",
      },
      {
        accessorKey: "segment1Name",
        header: "Tên phân đoạn 1",
      },
      {
        accessorKey: "segment6Code",
        header: "Mã phân đoạn 6",
      },
      {
        accessorKey: "segment6Name",
        header: "Tên phân đoạn 6",
      },
      {
        accessorKey: "plvt1Code",
        header: "Mã plvt 1",
      },
      {
        accessorKey: "plvt1Name",
        header: "Tên plvt 1",
      },
      {
        accessorKey: "plvt3Code",
        header: "Mã plvt 3",
      },
      {
        accessorKey: "plvt3Name",
        header: "Tên plvt 3",
      },
      {
        accessorKey: "plvt4Code",
        header: "Mã plvt 4",
      },
      {
        accessorKey: "plvt4Name",
        header: "Tên plvt 4",
      },
      {
        accessorKey: "plvt5Code",
        header: "Mã plvt 5",
      },
      {
        accessorKey: "plvt5Name",
        header: "Tên plvt 5",
      },
      {
        accessorKey: "plvt6Code",
        header: "Mã plvt 6",
      },
      {
        accessorKey: "plvt6Name",
        header: "Tên plvt 6",
      },
    ],
    [],
  );

  const getColumnVisibility = () => ({
    id: false,
    donGiaNhap: Boolean(isSearchWithItemCodeOrSerial),
  });

  const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>{dataItemCode.find((x) => x.value === option.value)?.label}</Text>
    </Group>
  );
  // Sử dụng debounce để trì hoãn việc gọi API
  const debouncedDataItemCode = useDebouncedCallback((value: string) => {
    if (value.length >= 3) {
      DataItemCode(value); // Gọi API với từ khóa tìm kiếm
    }
  }, 500);

  const exportDataExcel = async () => {
    open();
    try {
      let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
        pagination.pageSize
      }`;
      if (search.branchCode && search.branchCode.length > 0) {
        search.branchCode.forEach((branchCode) => {
          url += `&BranchCode=${branchCode}`;
        });
      }
      if (search.invCode && search.invCode.length > 0) {
        search.invCode.forEach((invCode) => {
          url += `&InvCode=${invCode}`;
        });
      }
      if (search.itemCode && search.itemCode.length > 0) {
        search.itemCode.forEach((itemCode) => {
          url += `&ItemCode=${itemCode}`;
        });
      }
      if (search.maChungs && search.maChungs.length > 0) {
        url += search.maChungs?.map((item) => `&MaChungs=${item}`).join("");
      }
      if (keySearch) {
        url += `&KeySearch=${keySearch.trim().toLowerCase()}`;
      }
      if (serial) {
        url += `&SerialList=${serial.trim().toLowerCase()}`;
      }
      const baseUrl = `/api/v1/ExportExcel/export-inventory-serial-report${url}`;

      const _url = BASE_API_DELIVERY + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
        },
      });
      if (!response.ok) {
        const errorResponse = await response.json();
        const errorMessage =
          errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
        throw new Error(errorMessage);
      }
      const blob = await response.blob();
      const urlss = window.URL.createObjectURL(blob);
      let filename = "bao_cao_ton_kho_theo_ma_vach.xlsx";
      const link = document.createElement("a");
      link.href = urlss;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(urlss);
    } catch (error: any) {
      console.log("error", error);
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!",
      );
    } finally {
      close();
    }
  };

  const exportDataExcelSll = async () => {
    open();
    try {
      const body: any = {
        Skip: pagination?.pageIndex * pagination?.pageSize,
        Take: pagination.pageSize,
      };

      if (search.branchCode && search.branchCode.length > 0) {
        body.BranchCode = search.branchCode;
      }
      if (search.invCode && search.invCode.length > 0) {
        body.InvCode = search.invCode;
      }
      if (search.itemCode && search.itemCode.length > 0) {
        body.ItemCode = search.itemCode;
      }
      if (search.maChungs && search.maChungs.length > 0) {
        body.MaChungs = search.maChungs;
      }
      if (keySearch) {
        body.KeySearch = keySearch.trim().toLowerCase();
      }
      if (serial) {
        body.SerialList = serial.trim().toLowerCase();
      }

      const baseUrl = `/api/v1/TblInventorySerialOnhand/export-list-serial-sll`;
      const _url = BASE_API_DELIVERY + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
        },
        body: JSON.stringify(body),
      });

      if (response.status === 200) {
        NotificationExtension.Success("Yêu cầu xuất đã vào hàng đợi.");
      } else {
        // read server error text if available
        let text = "";
        try {
          text = await response.text();
          console.error("Export failed response text:", text);
        } catch (e) {
          console.error(e);
        }
        NotificationExtension.Fails("Export Excel thất bại !");
      }
    } catch (error: any) {
      console.log("error", error);
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!",
      );
    } finally {
      close();
    }
  };
  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;
    if (search.invCode && search.invCode.length > 0) {
      search.invCode.forEach((invCode) => {
        url += `&InvCode=${invCode}`;
      });
    }
    if (search.branchCode && search.branchCode.length > 0) {
      search.branchCode.forEach((branchCode) => {
        url += `&BranchCode=${branchCode}`;
      });
    }
    if (search.itemCode && search.itemCode.length > 0) {
      search.itemCode.forEach((itemCode) => {
        url += `&ItemCode=${itemCode}`;
      });
    }
    if (keySearch) {
      url += `&KeySearch=${keySearch.trim().toLowerCase()}`;
    }
    if (serial) {
      url += `&SerialList=${serial}`;
    }
    if (search.maChungs && search.maChungs.length > 0) {
      url += search.maChungs?.map((item) => `&MaChungs=${item}`).join("");
    }
    try {
      const response = await repositoryDelivery.get(
        `/api/v1/TblInventorySerialOnhand/get-list-serial${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();

        if (
          serial.length > 0 ||
          (search.itemCode &&
            Array.isArray(search.itemCode) &&
            search.itemCode.length > 0)
        ) {
          setIsSearchWithItemCodeOrSerial(true);
        } else {
          setIsSearchWithItemCodeOrSerial(false);
        }
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
          serial: serial,
        }),
      );
    }
  };

  const DataInvCode = async () => {
    const branchSearch = dataBranchIdSelect
      .map((item: string) => `&BranchId=${item}`)
      .join("");

    const take = search?.branchCode?.length * 50;

    const res = await repositoryDelivery.get<MessageResponse<any>>(
      `/api/v1/TblDmInventory/get-list-by-branchs?Skip=0&Take=${
        search?.branchCode && search?.branchCode?.length > 0 ? take : 1000
      }${branchSearch}`,
    );

    if (res && res.success) {
      const result = res.data;
      const data = result
        ?.filter((item: any) => item.idBranch && item.name)
        ?.map((item: any) => ({
          label: `${item.code} - ${item.name}`,
          value: item.code?.toString(),
        }));
      setDataInvCode(data);
    }
  };

  const DataBrachCode = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res.filter((i) => i.att1 && i.value && i.text);

      setDataBranchCode(data);
    }
  };

  const DataItemCode = async (keySearch: string) => {
    try {
      let url = "";
      if (keySearch && keySearch.length > 0) {
        url += `&ItemCodes=${keySearch}`;
      }
      // const response = await repositoryDelivery.get(
      //   `api/v1/TblInventorySerialOnhand/get-list-item-by-inv?Skip=0&Take=50` +
      //     url
      // );
      const response = await repositoryPos.get(
        `/api/v1/TblItem/get-select?Key=${keySearch}&Page=30`,
      );
      if (response && response.success) {
        // const transformedData = response.data
        //   ?.filter((i: any) => i.maSp && i.tenSp)
        //   .map((branch: any) => ({
        //     value: branch.maSp,
        //     label: branch.maSp + " - " + branch.tenSp,
        //   }));
        const transformedData = response.data
          ?.filter((i: any) => i.value && i.text)
          .map((branch: any) => ({
            value: branch.value,
            label: branch.text,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value)),
        ).map((value) =>
          transformedData.find((item: any) => item.value === value),
        );
        setDataItemCode(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const fetchCatSegment4d = async () => {
    let url = "/api/v1/TblCatSegment4d/get-list?Skip=0&Take=20";

    if (searchCatSegment4d && searchCatSegment4d.length > 0) {
      url += `&CodeString=${searchCatSegment4d}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment4d(dataAPI);
    }
  };

  useEffect(() => {
    fetchCatSegment4d();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    const listId = dataBranchCode
      ?.filter((item) =>
        (search?.branchCode as string[])?.includes(String(item.att1)),
      )
      ?.map((item) => String(item.value));

    setDataBranchIdSelect(listId);
  }, [search.branchCode]);

  useEffect(() => {
    DataInvCode();
  }, [dataBranchIdSelect]);

  useEffect(() => {
    if (debounceCatSegment4d && debounceCatSegment4d.length > 4) {
      fetchCatSegment4d();
    }
  }, [debounceCatSegment4d]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (155 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableStickyFooter: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,
    rowCount,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "maSp"],
        right: ["statusName"],
      },
      columnVisibility: getColumnVisibility(),
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    // getRowId: (row) => row.departmentId,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  React.useEffect(() => {
    const newColumnVisibility = getColumnVisibility();
    if (table) {
      table.setColumnVisibility(newColumnVisibility);
    }
  }, [search.itemCode, serial, table, isSearchWithItemCodeOrSerial]);

  return (
    <Box>
      <LoadingOverlayCustom visible={visible} />
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Group justify="space-between" gap={0}>
          <_breadcrumb></_breadcrumb>
          <Flex direction="row" gap={10}>
            <Button
              leftSection={
                <IconFileExport style={{ width: rem(14), height: rem(14) }} />
              }
              onClick={() => exportDataExcel()}
            >
              Export Excel
            </Button>
            <Button
              leftSection={
                <IconFileExport style={{ width: rem(14), height: rem(14) }} />
              }
              onClick={() => exportDataExcelSll()}
            >
              Export Excel Sll
            </Button>
          </Flex>
        </Group>
        <Grid mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              placeholder="Nhập tìm kiếm"
              type="text"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              defaultValue={keySearch}
              onChange={(e) => {
                setKeySearch(e.target.value);
              }}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Nhập mã sản phẩm"
              clearable
              searchable
              data={dataItemCode.map((x) => x.value)} // Hiển thị kết quả từ API
              value={search.itemCode}
              renderOption={renderMultiSelectOption}
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              // onSearchChange={(value) => {
              //   if (value.length >= 3) {
              //     DataItemCode(value); // Gọi API với từ khóa tìm kiếm
              //   }
              // }}
              onSearchChange={(value) => {
                debouncedDataItemCode(value); // Sử dụng debounce
              }}
              onChange={(value) => {
                handleChangeSearchValue(value, "itemCode");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Input
              placeholder="Nhập mã vạch"
              type="text"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              defaultValue={serial}
              onChange={(e) => {
                setSerial(e.target.value);
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Chi nhánh"
              clearable
              searchable
              value={search.branchCode}
              data={dataBranchCode?.map((item) => ({
                label: `${item.att1} - ${item.text}`,
                value: String(item.att1),
              }))}
              leftSection={<IconBuildingSkyscraper size={20} color="#15aabf" />}
              onChange={(value) => {
                handleChangeSearchValue(value ? value : null, "branchCode");
              }}
              onClick={() => {
                if (dataBranchCode.length === 0) {
                  DataBrachCode();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Kho"
              searchable
              clearable
              data={dataInvCode}
              value={search.invCode}
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
              onChange={(value) => {
                handleChangeSearchValue(value, "invCode");

                // const _key = value.target.value ?? ""; // Nếu value là mảng
                // setKeySearch(_key);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Nhập mã chủng"
              clearable
              searchable
              searchValue={searchCatSegment4d}
              onSearchChange={(e) => setSearchCatSegment4d(e)}
              data={dataCatSegment4d}
              value={search.maChungs}
              onChange={(value) => {
                handleChangeSearchValue(value, "maChungs");
              }}
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 6, md: 6, lg: 0.9 }}>
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default InventoryReportByBarcodeV2;
